// extracted by mini-css-extract-plugin
export default {"container":"SearchForm_container__yYh5O","textarea":"SearchForm_textarea__gMUoJ","button":"SearchForm_button__arepV"};